export const menus = [
  {
    title: '솔루션 소개',
    url: 'solution',
    children: [
      {
        title: '포스',
        url: 'pos',
      },
      {
        title: '키오스크',
        url: 'kiosk',
      },
      {
        title: '우키키',
        url: 'ukiki',
      },
      {
        title: '매장관리',
        url: 'management',
      },
    ],
  },
  {
    title: '제품 소개',
    url: 'hardware',
    children: [
      {
        title: '포스',
        url: 'pos',
      },
      {
        title: '키오스크',
        url: 'kiosk',
      },
      {
        title: '담배 자판기',
        url: 'others',
      },
    ],
  },
  {
    title: '다양한 업종',
    url: 'case',
    children: [
      {
        title: '요식업',
        url: 'catering',
      },
      {
        title: '마라탕',
        url: 'spicy_hot_pot',
      },
      {
        title: '무인매장',
        url: 'unmanned',
      },
    ],
  },
  {
    title: '고객지원',
    url: 'support',
    children: [
      {
        title: 'FAQ',
        url: 'faq',
      },
      {
        title: '자료실',
        url: 'archive',
      },
      {
        title: '이용 가이드',
        url: 'https://unospay.notion.site/86043806c1c14d719f0de5f528285c7e',
        isExternal: true,
      },
    ],
  },
  {
    title: '공지사항',
    url: 'notice',
    children: [
      {
        title: '우노스 소식',
        url: 'news',
      },
      {
        title: '업데이트',
        url: 'update',
      },
    ],
  },
];
